<div class="container-fluid">
  <div class="d-flex gap-1">

    <mat-form-field appearance="outline">
      <mat-label>Centre Name</mat-label>
      <mat-select [formControl]="SelectCentre" (selectionChange)="onCentreChange($event)">
        <mat-option value="All">All Centres</mat-option>
        <mat-option *ngFor="let c of (centres$ | async)" [value]="c.centreCode">
          {{ c.centreName }}
        </mat-option>
      </mat-select>
    </mat-form-field>

<!--    <mat-form-field appearance="outline">-->
<!--      <mat-label>Teacher</mat-label>-->
<!--      <mat-select [(value)]="mTeacher">-->
<!--        <mat-option value="All">All</mat-option>-->
<!--        <mat-option *ngFor="let t of teachers$ | async" [value]="t.userName">-->
<!--          {{ t.userName }}-->
<!--        </mat-option>-->
<!--      </mat-select>-->
<!--    </mat-form-field>-->

    <mat-form-field appearance="outline">
      <mat-label>Date Range</mat-label>
      <mat-date-range-input [rangePicker]="picker">
        <input matStartDate placeholder="From date" [formControl]="startDate">
        <input matEndDate placeholder="To date" [formControl]="endDate">
      </mat-date-range-input>
      <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
      <mat-date-range-picker #picker></mat-date-range-picker>
    </mat-form-field>

    <button mat-mini-fab color="accent" (click)="search()">
      <mat-icon>search</mat-icon>
    </button>
    <button mat-mini-fab color="accent" (click)="clearAll()">
      <mat-icon>clear</mat-icon>
    </button>

  </div>

  <div class="ngxTableHeader">
    <ul class="header-buttons-left ms-0 mb-0">
      <li class="dropdown">
        <h2>Education Induction List</h2>
      </li>

      <li class="dropdown m-l-20">
        <label><i class="material-icons search-icon">search</i></label>
        <input placeholder="Search" type="text" class="browser-default search-field"
               (keyup)="applyFilter($event)" aria-label="Search box">
      </li>
    </ul>

    <ul class="header-buttons mr-2">
      <li>
        <button class="mr-2" mat-mini-fab color="primary" (click)="addInduction()" permission="Education Induction" [permissionTypes]="[PermissionType.ADD, PermissionType.ALL]">
          <mat-icon class="col-white">add</mat-icon>
        </button>
      </li>
      <li>
        <button
          mat-mini-fab
          color="accent"
          matTooltip="Download Excel"
          (click)="downloadExcel()" permission="Education Induction" [permissionTypes]="[PermissionType.EXCEL, PermissionType.ALL]">
          <mat-icon>download</mat-icon>
        </button>
      </li>

    </ul>
  </div>

  <table mat-table [dataSource]="dataSource" class="mat-elevation-z2 w-100">

    <ng-container matColumnDef="srNo">
      <th mat-header-cell *matHeaderCellDef> Sr.No. </th>
      <td mat-cell *matCellDef="let row; let i = index"> {{ i + 1 }} </td>
    </ng-container>

    <ng-container matColumnDef="inductionFor">
      <th mat-header-cell *matHeaderCellDef> Induction For</th>
      <td mat-cell *matCellDef="let row"> {{ row.inductionFor || 'NA' }} </td>
    </ng-container>

    <ng-container matColumnDef="inductionCentreName">
      <th mat-header-cell *matHeaderCellDef> Induction For Centre </th>
      <td mat-cell *matCellDef="let row"> {{ row?.inductionCentreName }} </td>
    </ng-container>

        <ng-container matColumnDef="createdAt">
          <th mat-header-cell *matHeaderCellDef> Created Date </th>
          <td mat-cell *matCellDef="let row"> {{ row.createdAt?.toDate() | date }} </td>
        </ng-container>

    <ng-container matColumnDef="actions">
      <th mat-header-cell *matHeaderCellDef> Actions </th>
      <td mat-cell *matCellDef="let row">
        <button mat-icon-button color="accent"
                (click)="view(row)"
                permission="Education Induction"
                [permissionTypes]="[PermissionType.VIEW, PermissionType.ALL]">
          <mat-icon>visibility</mat-icon>
        </button>
        <button mat-icon-button color="primary" (click)="edit(row)"  permission="Education Induction" [permissionTypes]="[PermissionType.EDIT]">
          <mat-icon>edit</mat-icon>
        </button>
        <button mat-icon-button color="warn" (click)="delete(row.id)" permission="Education Induction" [permissionTypes]="[PermissionType.ARCHIVE]">
          <mat-icon>delete</mat-icon>
        </button>
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
    <tr class="mat-row" *matNoDataRow>
      <td
        class="mat-cell text-center py-4"
        [attr.colspan]="displayedColumns.length">
        No data available
      </td>
    </tr>
  </table>

  <mat-paginator [pageSizeOptions]="[10, 25, 50, 100, 200]" showFirstLastButtons></mat-paginator>
</div>
